/**
 * Warm chunks before navigation. Attach to Link/NavLink onMouseEnter and
 * onTouchStart — by the time the click fires the chunks are already cached.
 *
 * No-op if module already loaded; the import map dedupes.
 */

const importers: Record<string, () => Promise<unknown>> = {
  supabase: () => import("@/integrations/supabase/client"),
  auth: () => import("@/pages/Auth"),
  products: () => import("@/pages/Products"),
  services: () => import("@/pages/Services"),
  myOrders: () => import("@/pages/MyOrders"),
  wallet: () => import("@/pages/Wallet"),
};

export type PreloadKey = keyof typeof importers;

export function preload(...keys: PreloadKey[]) {
  for (const k of keys) {
    try { importers[k](); } catch { /* ignore */ }
  }
}

/** Spread on <Link {...preloadIntent("auth", "supabase")} /> */
export function preloadIntent(...keys: PreloadKey[]) {
  const handler = () => preload(...keys);
  return { onMouseEnter: handler, onTouchStart: handler, onFocus: handler };
}
